export const GMAIL_IMPORT = 'mailboxes/GMAIL_IMPORT'
export const GMAIL_IMPORT_STARTED = 'mailboxes/GMAIL_IMPORT_STARTED'
export const GMAIL_IMPORT_SUCCESS = 'mailboxes/GMAIL_IMPORT_SUCCESS'
export const GMAIL_IMPORT_FAILED = 'mailboxes/GMAIL_IMPORT_FAILED'

export const SEND_VERIFICATION = 'mailboxes/SEND_VERIFICATION'
export const SEND_VERIFICATION_STARTED = 'mailboxes/SEND_VERIFICATION_STARTED'
export const SEND_VERIFICATION_SUCCESS = 'mailboxes/SEND_VERIFICATION_SUCCESS'
export const SEND_VERIFICATION_FAILED = 'mailboxes/SEND_VERIFICATION_FAILED'

export const SEND_SETUP_INSTRUCTIONS = 'mailboxes/SEND_SETUP_INSTRUCTIONS'
export const SEND_SETUP_INSTRUCTIONS_STARTED =
  'mailboxes/SEND_SETUP_INSTRUCTIONS_STARTED'
export const SEND_SETUP_INSTRUCTIONS_SUCCESS =
  'mailboxes/SEND_SETUP_INSTRUCTIONS_SUCCESS'
export const SEND_SETUP_INSTRUCTIONS_FAILED =
  'mailboxes/SEND_SETUP_INSTRUCTIONS_FAILED'

export const SEND_TEST_EMAIL = 'mailboxes/SEND_TEST_EMAIL'
export const SEND_TEST_EMAIL_STARTED = 'mailboxes/SEND_TEST_EMAIL_STARTED'
export const SEND_TEST_EMAIL_SUCCESS = 'mailboxes/SEND_TEST_EMAIL_SUCCESS'
export const SEND_TEST_EMAIL_RECEIVED = 'mailboxes/SEND_TEST_EMAIL_RECEIVED'
export const SEND_TEST_EMAIL_FAILED = 'mailboxes/SEND_TEST_EMAIL_FAILED'

export const FETCH_MAILBOXES = 'mailboxes/FETCH_MAILBOXES'
export const FETCH_MAILBOXES_STARTED = 'mailboxes/FETCH_MAILBOXES_STARTED'
export const FETCH_MAILBOXES_SUCCESS = 'mailboxes/FETCH_MAILBOXES_SUCCESS'
export const FETCH_MAILBOXES_FAILED = 'mailboxes/FETCH_MAILBOXES_FAILED'

export const UPDATE_MAILBOX = 'mailboxes/UPDATE_MAILBOX'
export const UPDATE_MAILBOX_STARTED = 'mailboxes/UPDATE_MAILBOX_STARTED'
export const UPDATE_MAILBOX_SUCCESS = 'mailboxes/UPDATE_MAILBOX_SUCCESS'
export const UPDATE_MAILBOX_FAILED = 'mailboxes/UPDATE_MAILBOX_FAILED'

export const TEST_SMTP = 'mailboxes/TEST_SMTP'
export const TEST_SMTP_STARTED = 'mailboxes/TEST_SMTP_STARTED'
export const TEST_SMTP_SUCCESS = 'mailboxes/TEST_SMTP_SUCCESS'
export const TEST_SMTP_FAILED = 'mailboxes/TEST_SMTP_FAILED'

export const CHECK_DNS = 'mailboxes/CHECK_DNS'
export const CHECK_DNS_STARTED = 'mailboxes/CHECK_DNS_STARTED'
export const CHECK_DNS_SUCCESS = 'mailboxes/CHECK_DNS_SUCCESS'
export const CHECK_DNS_FAILED = 'mailboxes/CHECK_DNS_FAILED'

export const DESTROY_MAILBOX = 'mailboxes/DESTROY_MAILBOX'
export const DESTROY_MAILBOX_STARTED = 'mailboxes/DESTROY_MAILBOX_STARTED'
export const DESTROY_MAILBOX_SUCCESS = 'mailboxes/DESTROY_MAILBOX_SUCCESS'
export const DESTROY_MAILBOX_FAILED = 'mailboxes/DESTROY_MAILBOX_FAILED'
